// extracted by mini-css-extract-plugin
module.exports = {"AddNewNote":"AddNewNote_AddNewNote__1idek"};